import React from 'react';
import { getTemplate } from 'TRANSLATION';
const Content = getTemplate('hint/CompanyHasUsPerson');

export default function CompanyHasUsPerson() {
  return <Content />;
}
